import styled from "@emotion/styled";
import { clock } from "constants/dimensions";

export const Container = styled.div({
  position: "absolute",
  left: clock.x,
  top: clock.y,
});
